const FlowActionTypes = {
  SET_INITIALIZED: "flow/SET_INITIALIZED",
  SET_LOADING: "flow/SET_LOADING",
  SET_FILTER: "flow/SET_FILTER",
  SET_ATTENDANCE_FILTER: "flow/SET_ATTENDANCE_FILTER",
  SET_TRAVEL_TIME_FILTER: "flow/SET_TRAVEL_TIME_FILTER",
  SET_SELECTED_LAYERS: "flow/SET_SELECTED_LAYERS",
  SET_GENERAL_STATS: "flow/SET_GENERAL_STATS",
  SET_MAP_INFOS: "flow/SET_MAP_INFOS",
  SET_DETAILS_STATS: "flow/SET_DETAILS_STATS",
  SET_DISTRIBUTION_STATS: "flow/SET_DISTRIBUTION_STATS",
  SET_ATTENDANCE_GRAPH: "flow/SET_ATTENDANCE_GRAPH",
  SET_TRAVEL_TIME_GRAPH: "flow/SET_TRAVEL_TIME_GRAPH",
  SET_CHRONOLOGY_GRAPH: "flow/SET_CHRONOLOGY_GRAPH",
  SET_AUTO_REFRESH: "flow/SET_AUTO_REFRESH",
  SET_ATTENDANCE_TIME_LIMIT: "flow/SET_ATTENDANCE_TIME_LIMIT",
  SET_CHRONOLOGY_TIME_LIMIT: "flow/SET_CHRONOLOGY_TIME_LIMIT",
  SET_TRAVEL_TIME_LIMIT: "flow/SET_TRAVEL_TIME_LIMIT",
  SET_TRAFFIC_INFOS: "flow/SET_TRAFFIC_INFOS",
  SET_CHRONOLOGY_TIME_FILTER: "flow/SET_CHRONOLOGY_TIME_FILTER",
  SET_CATEGORY_COUNT_GRAPH: "flow/SET_CATEGORY_COUNT_GRAPH",
  SET_CATEGORY_COUNT_TIME_FILTER: "flow/SET_CATEGORY_COUNT_TIME_FILTER",
  SET_TRAFFIC_CHART: "flow/SET_TRAFFIC_CHART",
  SET_TRAFFIC_CHART_TIME_FILTER: "flow/SET_TRAFFIC_CHART_TIME_FILTER",
  SET_TRAFFIC_CHART_INITIALIZED: "flow/SET_TRAFFIC_CHART_INITIALIZED",
};

export default FlowActionTypes;
